<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>销售通话记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="85" :show-message="false">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="通话日期:">
              <DatePicker :value="defaultDate" @on-change="atimeDateChange" format="yyyy-MM-dd" type="daterange"
                          placement="bottom-start" placeholder="默认当天" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="手机号">
              <Input placeholder="被呼叫的号码" name="mobile" v-model="queryParam.mobile"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="员工名称">
              <Input placeholder="员工名称" name="ecUserName" v-model="queryParam.ecUserName"/>
            </Form-item>
          </Col>
          <Col span="4">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">
              搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-group">
      <Row>
<!--        <Button type="primary" @click="exportData">导出</Button>-->
        <Button type="primary" @click="syncSalesUser">同步销售工号</Button>
        <Button type="primary" @click="SynchronousData">同步记录</Button>
      </Row>
    </div>
    <List :tableColumns="tableColumns" listUrl="/call_record/page-list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      page-route="/crm/PhoneRecordList"
      default-task-type="SALES_FOLLOWUP"
      @on-executed="onAiExecuted"
      @on-close="onAiClose"
    />
  </div>
</template>

<script>
import SalesAdviserSelect from '../common/SalesAdviserSelect.vue'
import AiDrawer from '@/components/ai/AiDrawer'
import { bindAiAllowed } from '@/tools/aiAccess'

export default {
  components: {SalesAdviserSelect, AiDrawer},
  data() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const yesterdayStr = yesterday.toISOString().split('T')[0];
    return {
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      selectionUser: [],
      timeDateChange: '',
      searchLoading: false,
      defaultDate: [yesterdayStr, yesterdayStr],
      queryParam: {
        ecUserName: '',
        beginTime: yesterdayStr,
        endTime: yesterdayStr,
        mobile: ''
      },
      tableColumns: [
        {
          title: '员工',
          key: 'callerId',
          align: 'center',
        },
        {
          title: '通话时间',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', {style: {margin: '0'}}, params.row.beginTime),
              h('p', {style: {margin: '0'}}, '通话时长:' + this.time(params.row.hold))
            ])
          }
        },
        {
          title: '被呼叫号码',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', {style: {margin: '0'}}, params.row.calleeId),
              h('p', {style: {margin: '0'}}, '学生ID:' + params.row.uid)
            ])
          }
        },
        {
          title: '备注',
          align: 'center',
          key: 'content',
        },
        {
          title: '录音',
          align: 'center',
          key: 'recordUrl',
          render: (h, params) => {
            const audioUrl = params.row.recordUrl
            if (audioUrl) {
              if (audioUrl === '失败') {
                return h('span', '无录音')
              }
              return h('audio', {
                attrs: {
                  src: audioUrl,
                  controls: true // 显示播放控件
                },
                style: {
                  width: '100%'
                }
              });
            } else {
              return h('span', '无录音')
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 80,
          render: (h, params) => {
            const uid = params.row.uid
            if (!uid) {
              return h('span', {style: {color: '#c5c8ce'}}, '无学生')
            }
            if (!this.aiAllowed) {
              return h('span', '')
            }
            return h('a', {on: {click: () => this.openAiDrawer(uid)}}, 'AI')
          }
        }

      ],
    }
  },
  mounted: function () {
  },
  created: function () {
    bindAiAllowed(this)
  },
  methods: {
    getYesterday() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday.toISOString().split('T')[0]; // 返回格式为 YYYY-MM-DD
    },
    onLoading(loading) {
      this.searchLoading = loading
    },
    time(time) {
      let sTime = time
      let mTime = 0
      let hTime = 0
      if (sTime > 60) {
        mTime = parseInt(sTime / 60);
        sTime = parseInt(sTime % 60);
        if (mTime > 60) {
          hTime = parseInt(mTime / 60);
          mTime = parseInt(mTime % 60);
        }
      }
      if (hTime === 0) {
        if (mTime === 0) {
          return sTime + '秒'
        }
        return mTime + '分' + sTime + '秒'
      }
      if (mTime === 0) {
        return sTime + '秒'
      }
      return hTime + '小时' + mTime + '分' + sTime + '秒'
    },
    atimeDateChange(value) {
      this.queryParam.beginTime = value[0]
      this.queryParam.endTime = value[1]
    },
    openAiDrawer (uid) {
      this.aiUid = uid
      this.aiVisible = true
    },
    onAiClose () {
      this.aiVisible = false
      this.aiUid = null
    },
    onAiExecuted () {
      this.reload = new Date().getTime()
    },
    search() {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    syncSalesUser() {
      this.$http.post('/moor/ec-transfer-user').then((response) => {
        if (response.status === 'ok') {
          this.$Message.success('同步销售工号成功')
        } else {
          this.$Message.error(response.msg || '同步失败')
        }
      }).catch(() => {
        this.$Message.error('请求失败')
      })
    },
    SynchronousData() {
      this.$http.post('/call_record/initqimodata').then((response) => {
        this.$Message.success('同步数据成功')
        this.search()
      })
    },
    exportData() {
      this.exportLoading = true
      this.$http.get('/call_record/exportPhone', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '销售通话记录.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    }
  }
}
</script>

<style scoped>
.btn-group {
  display: flex;
  justify-content: end;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// PhoneRecordList.vue?343275d2